import React from 'react';
import {
  TestimonialContainer,
  TestimonialContent,

  Author,
} from './Testimonial.styles';
// Removed actual image import and using a placeholder URL instead

const Testimonial: React.FC = () => {
  // Placeholder testimonial image URL


  return (
    <TestimonialContainer>
      <TestimonialContent>
        <blockquote>
          “At Hope Beyond International, every patient is embraced with compassion, and families are provided with the comfort and support they need during life’s most challenging times.”
        </blockquote>
        <Author>- HBI Team</Author>
      </TestimonialContent>
    </TestimonialContainer>
  );
};

export default Testimonial;